<template>
  <section id="trial" class="section--pt-xlg">
    <div class="inner">
      <h2 class="Head Head--cl01">
        <span class="Head__main Head--md">TRIAL CLASS</span><br><span class="Head__main_jp">MELONのトライアルクラス</span>
      </h2>
      <div class="Movie__area _mg-b20">
        <div class="Movie__inner">
          <iframe src="https://player.vimeo.com/video/491928988?h=5df40ddb40&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="20201216 Trial 15 by Sou" />
        </div>
      </div>
      <p class="_l-lg _mg-b20 _ft-cnt">
        トライアル動画では、マインドフルネスの簡単な説明、実践を15分で行います。<br>実践後の質疑応答の雰囲気も含めてご体験いただけるので、一度ご覧ください。
      </p>
    </div>
  </section>
</template>
<script>
export default {
  name: 'TrialClass'
}
</script>
